var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-subtitle-1 ml-4"},[_vm._v(_vm._s(_vm.date))])}
var staticRenderFns = []

export { render, staticRenderFns }